"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(12)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse rounded-none bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Errore nel caricamento del catalogo formativo.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Nessun corso di formazione disponibile al momento.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group flex flex-col overflow-hidden rounded-none bg-card border border-border shadow-sm transition-all hover:shadow-md">
          <div className="relative aspect-[16/9] overflow-hidden">
            {post.featuredImage || post.customFields?.featured_image ? <img src={post.customFields?.featured_image || post.featuredImage || 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/formazione_professionale.png'} alt={post.customFields?.title || post.title || 'Corso'} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-primary">
                <span className="text-primary-foreground font-mono text-xs">TECHNICAL_PREVIEW</span>
              </div>}
          </div>
          
          <div className="flex flex-grow flex-col p-6 md:p-8">
            <div className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent font-mono">
              <span>CERTIFICAZIONE</span>
              <span>&bull;</span>
              <span>
                {post.date ? new Date(post.date).toLocaleDateString("it-IT", {
              year: "numeric",
              month: "short"
            }) : "SESSIONE 2024"}
              </span>
            </div>
            
            <h3 className="mb-6 line-clamp-2 text-xl font-bold text-foreground transition-colors group-hover:text-accent font-default">
              {post.customFields?.title || post.title || 'Corso'}
            </h3>
            
            <div className="mt-auto">
              <Button asChild variant="outline" className="rounded-none border-primary bg-transparent px-6 py-5 text-xs font-bold uppercase tracking-widest text-primary transition-all hover:border-accent hover:bg-accent hover:text-accent-foreground">
                <Link to={post.link || "/SingleCoursePage"}>
                  DETTAGLI CORSO <ArrowUpRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function LatestNews() {
  const wp_query_params = {
    post_type: "post",
    per_page: 12,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}